import React, { FC } from 'react';
import cn from 'classnames';
import { CdnIcon, CdnIconNames } from '@shared/ui';
import { BaseButton, ModalX } from '../../../../../BaseComponents';
import { useTheme } from '../../../../../theme';
import { ExchangeRefundModalData } from '../../model';

interface Props extends ExchangeRefundModalData {
	className?: string;
}

const ExchangeRefundModal: FC<Props> = ({ className, status, title, description, cancel, success, close }) => {
	const { ExchangeRefundModal: theme } = useTheme('Entities').Order;

	const icon: CdnIconNames = status === 'success' ? 'Info/Item Icluded' : 'Info/Warning';

	return (
		<ModalX
			isOpen={true}
			onClose={close}
			classes={{ root: className, content: theme.content }}
			title={
				<div className={theme.header}>
					<div className={cn(theme.icon, theme[status])}>
						<CdnIcon icon={icon} />
					</div>

					{!!title && <span className={theme.title}>{title}</span>}
				</div>
			}
			footer={
				<div className={theme.footer}>
					{cancel && (
						<BaseButton className={theme.cancel} variant="secondary" onClick={cancel.onClick} fullWidth>
							{cancel.text}
						</BaseButton>
					)}

					{success && (
						<BaseButton variant="action" onClick={success.onClick} fullWidth>
							{success.text}
						</BaseButton>
					)}
				</div>
			}
		>
			{!!description && <span className={theme.description}>{description}</span>}
		</ModalX>
	);
};

export default ExchangeRefundModal;
